import { usePath } from "../libs/path/PathProvider";
import SearchInput from "../gui/TextInput/SearchInput";
import { useState } from "react";
import { UpdateEvent } from "../gui/GUIEvents";
import SearchIcon from "../gui/Icons/SearchIcon";

export default function Search(props:{className:string}){
    const {query,setQuery} = usePath()
    const [search,setSearch] = useState<string>(query["s"] as string || "")
    
    const onSearch = (text:string) => setQuery({s:text})
    const onUpdate = (e:UpdateEvent<string>) => setSearch(e.value!)
    return <div id="search" className={props.className}>
        <SearchInput id="textSearch" onSearch={onSearch} value={search} placeholder="Search" float={true} onUpdate={onUpdate} canClear={true} preIcon={<SearchIcon/>}/>
    </div>
}